(() => {
  const format = (cents) => window.NL && window.NL.formatMoney
    ? window.NL.formatMoney(cents, { trimZeros: true }) : String(Number(cents || 0) / 100);
  const setup = (root) => {
    if (root.dataset.v5Bound) return;
    root.dataset.v5Bound = 'true';
    const form = root.querySelector('.nl-v5-pdp__purchase form[id^="ProductForm-"]');
    if (!form) return;
    const qty = form.querySelector('input[name="quantity"]');
    const packs = form.querySelector('[data-v5-packs]');
    const price = root.querySelector('[data-v5-unit-price]');
    let unit = Number(price && price.dataset.cents) || 0;
    const calc = (count) => {
      const discount = packs && packs.dataset.discount === 'true' && (count === 2 || count === 3)
        ? Number(packs.dataset[`discount${count}`]) || 0 : 0;
      return Math.round(unit * count * (100 - discount) / 100);
    };
    const sync = () => {
      const count = Math.max(1, Math.floor(Number(qty && qty.value) || 1));
      if (packs) {
        packs.querySelectorAll('[data-v5-pack]').forEach((button) => {
          const n = Number(button.dataset.v5Pack);
          button.setAttribute('aria-pressed', String(n === count));
          const label = button.querySelector('[data-v5-pack-price]');
          if (label) label.textContent = format(calc(n));
        });
      }
      const total = format(calc(count));
      const atc = root.querySelector('[data-v5-atc-price]');
      const bar = root.querySelector('[data-v5-bar-price]');
      const anchorPrice = document.querySelector('[data-v3-anchors] [data-v3-price]');
      if (atc) atc.textContent = total;
      if (bar) bar.textContent = total;
      if (anchorPrice) {
        anchorPrice.textContent = total;
        anchorPrice.dataset.cents = String(calc(count));
      }
    };
    if (packs && qty) packs.addEventListener('click', (event) => {
      const button = event.target.closest('[data-v5-pack]');
      if (!button) return;
      qty.value = button.dataset.v5Pack;
      qty.dispatchEvent(new Event('change', { bubbles: true }));
      sync();
    });
    if (qty) {
      qty.addEventListener('change', sync);
      qty.addEventListener('input', sync);
    }
    document.addEventListener('variant:change', (event) => {
      if (event.detail && event.detail.sectionId === root.id.replace('Pdp-', '') && event.detail.variant) {
        unit = Number(event.detail.variant.price) || 0;
        sync();
      }
    });
    sync();
  };
  const emphasizeIntro = (root) => {
    if (root.dataset.v5Done) return;
    root.dataset.v5Done = 'true';
    const pattern = /(?<![\p{L}\p{N}-])\d+(?:[ \u00a0]\d{3})*(?:[,.]\d+)?[ \u00a0]*(?:µg|mg|g|IU|%|kapslí)(?![\p{L}\p{N}])/giu;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach((node) => {
      const text = node.textContent;
      pattern.lastIndex = 0;
      if (!pattern.test(text)) return;
      pattern.lastIndex = 0;
      const fragment = document.createDocumentFragment();
      let from = 0;
      for (const match of text.matchAll(pattern)) {
        if (match.index > from) fragment.append(document.createTextNode(text.slice(from, match.index)));
        const strong = document.createElement('strong');
        strong.textContent = match[0];
        fragment.append(strong);
        from = match.index + match[0].length;
      }
      if (from < text.length) fragment.append(document.createTextNode(text.slice(from)));
      node.replaceWith(fragment);
    });
  };
  const scan = (scope = document) => scope.querySelectorAll('.nl-v5-pdp').forEach((root) => {
    setup(root);
    root.querySelectorAll('[data-v5-intro]').forEach(emphasizeIntro);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(), { once: true });
  else scan();
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
